/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClrLoadingModule } from "../../utils/loading/loading.module";
import { LOADING_BUTTON_DIRECTIVES } from "./index";
var ClrLoadingButtonModule = (function () {
    function ClrLoadingButtonModule() {
    }
    return ClrLoadingButtonModule;
}());
export { ClrLoadingButtonModule };
ClrLoadingButtonModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    ClrLoadingModule
                ],
                declarations: [LOADING_BUTTON_DIRECTIVES],
                exports: [
                    LOADING_BUTTON_DIRECTIVES,
                    ClrLoadingModule
                ]
            },] },
];
/** @nocollapse */
ClrLoadingButtonModule.ctorParameters = function () { return []; };
//# sourceMappingURL=loading-button.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/button/button-loading/loading-button.module.js
// module id = 144
// module chunks = 4